import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// HubSpot Tracking Component
const HubSpotTracking = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = '//js-na2.hs-scripts.com/244865033.js';
    document.body.appendChild(script);

    return () => {
      const existingScript = document.getElementById('hs-script-loader');
      if (existingScript) existingScript.remove();
    };
  }, []);
  
  return null;
};

// Page view tracking hook for SPA
export const usePageTracking = () => {
  const location = useLocation();
  
  useEffect(() => {
    if (window._hsq) {
      window._hsq.push(['setPath', location.pathname]);
      window._hsq.push(['trackPageView']);
    }
  }, [location.pathname]);
};

export default HubSpotTracking;
